// extracted by mini-css-extract-plugin
module.exports = {"entityDetails":"entityDetails_entityDetails__VgZKH","logo":"entityDetails_logo__1OkhI"};